const actions = {
  SEARCH_LOGISTIC_TOOLS: 'SEARCH_LOGISTIC_TOOLS',
  SEARCH_LOGISTIC_TOOLS_ENDED: 'SEARCH_LOGISTIC_TOOLS_ENDED',
  CREATE_LOGISTIC_TOOL: 'CREATE_LOGISTIC_TOOL',
  CREATE_LOGISTIC_TOOL_ENDED: 'CREATE_LOGISTIC_TOOL_ENDED',
  UPDATE_LOGISTIC_TOOL: 'UPDATE_LOGISTIC_TOOL',
  UPDATE_LOGISTIC_TOOL_ENDED: 'UPDATE_LOGISTIC_TOOL_ENDED',
  SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE: 'SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE',
  SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE_ENDED:
    'SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE_ENDED',
  SEARCH_LOGISTIC_ORDERS: 'SEARCH_LOGISTIC_ORDERS',
  SEARCH_LOGISTIC_ORDERS_ENDED: 'SEARCH_LOGISTIC_ORDERS_ENDED',
  SEARCH_LOGISTIC_ORDER_RECORDS: 'SEARCH_LOGISTIC_ORDER_RECORDS',
  SEARCH_LOGISTIC_ORDER_RECORDS_ENDED: 'SEARCH_LOGISTIC_ORDER_RECORDS_ENDED',
};

export default actions;
